import { Component, OnInit } from '@angular/core';
import { NavigationService } from 'src/app/___LOGIC/__navigation/navigation.service';

@Component({
  selector: 'app-banner-card',
  templateUrl: './banner-card.component.html',
  styleUrls: ['./banner-card.component.css']
})
export class BannerCardComponent implements OnInit {

  constructor(private navigationService: NavigationService) { }

  ngOnInit(): void {
  }

  goToForm(){
    this.navigationService.goToViewSection('sub-app/health-helper','solicitarInfoSeguro');
  }

}
